
export const SOFTLINE_SETTINGS_APPLICATION = 'application';
